module.exports = __webpack_public_path__ + "img/new_logo.be83e8bd.png";